export default "__VITE_ASSET__CL4kM1aH__"